// Libraries
import { v4 as uuidv4 } from "uuid";
import { Grid, Skeleton } from "@mui/material";

// Components
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";

export default function LoadingSkeleton() {
	return (
		<Grid container item mt={0} rowSpacing={2} columnSpacing={4}>
			{Array.from(Array(3)).map((_) => (
				<Grid key={uuidv4()} item xs={6} md={4}>
					<Skeleton variant="text" width={200} height={36} />
					<Skeleton variant="text" width={200} height={36} sx={{ marginLeft: "15px" }} />
					<TableLoader content rows={3} toolbar buttons={2} />
				</Grid>
			))}
		</Grid>
	);
}
